import { yaTidakFlagOptions } from '@/constants/flagAndCategory';

const headers = [
  { title: 'No. Receipt', key: 'code', sortable: true },
  { title: 'Nama Pembayar', key: 'payer_name', sortable: true },
  { title: 'Tgl. Bayar', key: 'payment_date', sortable: true },
  { title: 'Besar Pembayaran', key: 'payment_amount', align: 'end', sortable: true },
  { title: 'No. Invoice', key: 'invoice_code', sortable: true },
  { title: 'Void', key: 'is_void', sortable: true },
  { title: 'Created At', key: 'created_at', sortable: true },
  { title: 'Updated At', key: 'updated_at', sortable: true },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
];

const filters = [
  { title: 'No. Receipt', key: 'code', type: 'text' },
  { title: 'Nama Pembayar', key: 'payer_name', type: 'text' },
  { title: 'Tgl. Bayar (awal)', key: 'payment_date_from', type: 'date' },
  { title: 'Tgl. Bayar (akhir)', key: 'payment_date_to', type: 'date' },
  { title: 'No. Invoice', key: 'invoice_code', type: 'text' },
  { title: 'Void', key: 'is_void', type: 'select', selectOptions: yaTidakFlagOptions },
];

export { filters, headers };
